import * as React from "react";
import { useBloomreachPageRoutes, CmsComponentSlot, getPageRoot } from "@grandvisionhq/bloomreach";
import { Container } from "@grandvisionhq/elements";
import { useFeatureToggles } from "@grandvisionhq/state";
import { Hooks, StoreGroupRootV2, StoreGroupRoot, GroupPage } from "@grandvisionhq/stores-v2";
import "@grandvisionhq/fun-store-filters/dist/index.css";
const Page = ({
  bookAppointmentUrl,
  groupName,
  stores,
  storeSearchFilters
}) => {
  const { useDefaultStoreSearchFilters } = Hooks;
  const defaultStoreSearchFilters = useDefaultStoreSearchFilters();
  const { isStoreDetailsPhoneEnabled, isStoreDetailsEmailEnabled, isStoreFiltersStoresEnabled } = useFeatureToggles();
  const { routes } = useBloomreachPageRoutes();
  const urls = React.useMemo(
    () => ({
      bookAppointment: bookAppointmentUrl ?? `${routes["appointment-book"]}/what`,
      storeDetails: routes.stores || ""
    }),
    [routes, bookAppointmentUrl]
  );
  const StoreGroupRootComponent = isStoreFiltersStoresEnabled ? StoreGroupRootV2 : StoreGroupRoot;
  if (!stores) {
    console.error(
      `Tried to render a store group page but got invalid store group data: ${String(stores)}`
    );
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/top-container" }), /* @__PURE__ */ React.createElement(Container, { className: "store-group-layout" }, /* @__PURE__ */ React.createElement(
    StoreGroupRootComponent,
    {
      groupName,
      urls,
      stores,
      hidePhone: !isStoreDetailsPhoneEnabled,
      hideEmail: !isStoreDetailsEmailEnabled,
      storeSearchFilters: storeSearchFilters ?? defaultStoreSearchFilters
    }
  )), /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" }));
};
Page.getInitialProps = async (ctx) => {
  const { req, apolloClient, pageModel, pathname, featureToggles } = ctx;
  const {
    featureConfigs: { bloomreachRefPrefix }
  } = featureToggles;
  const pageRootComponent = getPageRoot(pageModel, bloomreachRefPrefix);
  const groupName = pageRootComponent?.meta.pageTitle;
  const locale = req?.locale?.toString();
  if (!locale) {
    console.error(`Can't extract locale from req`);
    return {};
  }
  if (!groupName) {
    console.error(`Can't extract groupName from pageModel`);
    return {
      statusCode: 404
    };
  }
  if (!apolloClient) {
    console.error(`ApolloClient not present in context for page ${pathname}`);
    return {
      statusCode: 500
    };
  }
  try {
    const pageData = await GroupPage.getPageData(apolloClient, groupName, locale);
    if (!pageData?.stores?.length) {
      return {
        statusCode: 404
      };
    }
    return {
      stores: pageData?.stores ?? void 0,
      groupName
    };
  } catch (err) {
    console.error(`Failed to fetch StoreGroup with groupName: ${groupName}.`, err);
    return {
      statusCode: 404
    };
  }
};
export {
  Page
};
//# sourceMappingURL=store-group.js.map
